import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { IToolCall } from '../../../models/tool-call.model';
import { ToolViewComponent } from '../../tool-views/tool-view.component';

@Component({
    selector: 'app-tool-panel',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SliderModule,
        SkeletonModule,
        ButtonModule,
        IconComponent,
        ToolViewComponent,
    ],
    templateUrl: './tool-panel.component.html',
    styleUrl: './tool-panel.component.scss'
})
export class ToolPanelComponent {
    //#region Inputs
    toolCall = input<IToolCall | null>(null);
    isLoading = input<boolean>(false);
    //#endregion

    //#region Expose icons for template
    //#endregion

    constructor() {

    }

}
